import React, { useState, useContext } from 'react';
import './login.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../authContext/auth';




function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
 
  

  const handleLogin = async (e) => {
    e.preventDefault();
    await login(email, password);
    const user = { email, password };
  
    try {
      const response = await fetch('http://localhost:3002/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
      });
  
      if (response.status === 200) {
        alert('Login successful');
    
        const timer = setTimeout(() => {
     
          navigate('/');
        }, 3000);
  
        return () => clearTimeout(timer);
      } else if (response.status === 400) {
        alert(''); 
      } else {
        alert('Incorrect email or password');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Server error');
    }
  };
  

  return (
    <div className="login-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="login-car">
              <h2>Login</h2>

              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label>Email*</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  
                </div>

                <div className="form-group">
                  <label>Password*</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                 
                </div>

                <button type="submit" className="btn btn-primary">
                  Login
                </button>
                
                <Link to="/signup" className="ml-3">
                  You don't have an account? Sign up here.
           
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
     

      
    </div>
  );
}

export default LoginPage;
